import React from "react";

import { User } from "@pollyslack/hub/src/types";

import { DocumentSearchPage } from "../../components/DocumentSearchPage";
import { UsersTable } from "../../components/UsersTable";

import { list } from "../../services/api/User";
import { PlatformTeamUsersPanel } from "./components/PlatformTeamUsersPanel";

export class UsersPage extends React.Component {
  public render() {
    return (
      <DocumentSearchPage
        typeName="User"
        placeholder="Mongo ID, Slack ID, Email, or Org ID"
        scopeToggles
        primaryHeading="Slack Workspace Identities"
        load={list}
        renderTable={(users: User[]) => {
          return <UsersTable users={users} />;
        }}
        renderExtra={(params) => (
          <PlatformTeamUsersPanel
            search={params.search}
            enabled={!!params.scopes?.platformTeam}
          />
        )}
      />
    );
  }
}
